<template>
  <general-layout class="alone-box">
    <template v-if="isRoot" #header>
      <east-operate>
        <template #left>
          <el-button @click="removeAll">删除全部记录</el-button>
          <el-button @click="removeBad">清理无效记录</el-button>
        </template>
      </east-operate>
    </template>
    <layui-table :data="taskMaps">
      <layui-table-column
        prop="dn"
        min-width="160"
        label="节点路径"
      ></layui-table-column>
      <layui-table-column
        prop="target"
        width="240"
        label="同步位置"
      ></layui-table-column>
      <layui-table-column width="90" align="center" label="同步类型">
        <template slot-scope="scope">
          <span class="text-danger" v-if="scope.row.type === SYNC_TYPE.None"
            >不同步</span
          >
          <span class="text-success" v-else>
            <span v-if="scope.row.type.hasFlag(SYNC_TYPE.ToUnit)">通讯录</span>
            <span v-else-if="scope.row.type.hasFlag(SYNC_TYPE.ToPub)"
              >公共联系人</span
            >
            <span v-else>类型未设置</span>
          </span>
        </template>
      </layui-table-column>
      <layui-table-column width="60" align="center" label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="handleCLick(scope.row)">
            修改
          </el-button>
        </template>
      </layui-table-column>
    </layui-table>
  </general-layout>
</template>

<script>
import SYNC_TYPE from "@/constant/syncType";
import LDAP from "@/api/sync/ldap";
import { mapState } from "vuex";

export default {
  name: "entry-alone",
  props: {
    dn: {
      type: String
    }
  },
  data() {
    return {
      SYNC_TYPE,
      taskMaps: []
    };
  },
  computed: {
    ...mapState(["options"]),
    isRoot: vm => vm.dn === vm.options.ldap.root
  },
  created() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      let response = await LDAP.ENTRY_ALONE({ dn: this.dn });
      if (response.data.state) {
        this.taskMaps = response.data.taskMaps;
      }
    },
    handleCLick(row) {
      this.$emit("select", row);
    },
    handleFresh() {
      console.log("alone 刷新!");
      this.fetchData;
    },
    async removeAll() {
      let response = await LDAP.REMOVE_TASK_MAP_ALL();
      if (response.data.state) {
        this.fetchData();
        this.$message.success("全部独立配置节点删除成功");
      } else {
        this.fetchData();
        this.$message.error(response.data.message);
      }
    },
    async removeBad() {
      let response = await LDAP.REMOVE_TASK_MAP_BAD();
      if (response.data.state) {
        this.fetchData();
        this.$message.success("无效独立配置节点清理成功");
      } else {
        this.fetchData();
        this.$message.error(response.data.message);
      }
    }
  }
};
</script>

<style scoped>
.alone-box {
  height: 480px;
}
</style>
